/**
 * https://www.sqlite.org/datatype3.html
 */
export const SQLiteTypes: string[] = [
  'BLOB',
  'INTEGER',
  'NUMERIC',
  'REAL',
  'TEXT',
];
